import API from "../../Api";
import {
  RestaurantMenuRequest,
  RestaurantsRequestParams,
  SubmitFeedbackDetail,
} from "./restaurantModels";
import { encryptJson } from "../../utils/react-ec-utils";
import { Store } from "../../configureStore";
import { USER_ID } from "../../constants";
import { getCookie } from "../../../helper/cookieHelper";

// Get Restaurants
export function getRestaurants(locationParams: RestaurantsRequestParams) {
  const data = encryptJson(locationParams)
  return API({
    method: "post",
    url: "/api/customers/findMerchant/v2",
    data: {"data": data},
  });
}

// Get Restaurant Details
export function getRestaurantDetails(slugId: string) {  
  const encryptedData = encryptJson({ slug: slugId }) 
  return API({
    method: 'post',
    url: '/api/customers/locations/slug',
    data: { data: encryptedData },
  });
  // return API({
  //   method: "get",
  //   url: "/merchants/info/" + slugId,
  // });
}

//  Get Restaurant details using location Id
export function getRestaurantDetailsbyLocationId(locationId: string) {
  const encryptedData = encryptJson({ staffId: null, locationId: locationId })
  return API({
    method: 'post',
    url: '/api/customers/locations/id',
    data: { data: encryptedData },
  });

  // return API({
  //   method: "get",
  //   url: `/merchants/location/${locationId}/details`,
  // });
}

export function getRestaurantMenuDetailsByEventDate(details: RestaurantMenuRequest) {
  const data = encryptJson({ eventSlug: details?.eventSlug, locationId: details?.locationId, orderType: details?.type })
  return API({
    method: "post",
    url: `/api/customers/locations/event-order-menu`,
    data:{'data':data}
  });
}

export function getRestaurantMenuDetails(details: any) {  
  const currentActivMenuType = (Store as any).getState().restaurant.currentActivMenuType;
  
  const updatedDetails = {
    ...details,
    visibleTo: Array.isArray(details.visibleTo) ? details.visibleTo : [details.visibleTo],
    type:details?.from =="s"?currentActivMenuType:details.type
  };
  
  const data = encryptJson(updatedDetails);

  return API({
    method: "post",
    url: "/api/customers/menu",
    data: { "data": data },
  });
}


export function getFeedbackDetails() {
  return API({
    method: "get",
    url: "/api/customers/fetch-feedback",
  });
}

export function submitFeedback(SubmitFeedbackDetails: SubmitFeedbackDetail) {
  const data=encryptJson(SubmitFeedbackDetails)
  return API({
    method: "post",
    url: "/api/customers/add-feedback",
    data: {"data":data},
  });
}

export function getmasterRestaurantHomePageDetails(slug: string) {
  const data=encryptJson({"slug":slug})
  return API({
    method: "post",
    url: `/api/customers/details/v2`,
    data:{'data': data}
  });
}

export function getRestaurantTableDetails(locationId: string) {
  let payload={"locationId":locationId}
  const data = encryptJson(payload);
  return API({
    method: "post",
    url: '/api/customers/locations/reservations/table-details',
    data:{'data': data}
  });
}

export function getSearchResult(
  lat: string,
  lng: string,
  keyword: string,
  page: number
) {
  return API({
    method: "get",
    url: `/search?text=${keyword}&page=${page}&size=25&latitude=${lat}&longitude=${lng}`,
  });
}

export function getExactSearchResult(
  lat: string,
  lng: string,
  keyword: string
) {
  return API({
    method: "get",
    url: `/search?text=${keyword}&isExactMatch=1&latitude=${lat}&longitude=${lng}`,
  });
}

//view address
export function viewDeliveryAddress() {
  const customerID = getCookie(USER_ID);
  // Don't make API call if customerID doesn't exist (e.g., after 403/401 or page refresh)
  if (!customerID) {
    return Promise.reject({ 
      response: { 
        status: 401, 
        data: { message: 'Customer ID not found' } 
      } 
    });
  }
  return API({
    method: "get",
    url: `/api/customers/order/fetch-address?customerId=${customerID}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//add delivery address
export function addDeliveryAddress(data: any) {
  return API({
    method: "post",
    url: `/api/customers/order/save-address`,
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//edit address
export function editDeliveryAddress(data: any) {
  const addressId = data?.id
  return API({
    method: "put",
    url: `/api/customers/order/update-address/${addressId}`,
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//delete address
export function deleteDeliveryAddress(data: any) {
  const addressId = data
  return API({
    method: "delete",
    url: `/api/customers/order/remove-address/${addressId}`,
  });
}

export function AddFav(data: any) {
  return API({
    method: "post",
    url: "/api/customers/add-favourites",
    data: data,
  });
}

export function removeFav(data: any) {
  return API({
    method: "delete",
    url: "/api/customers/remove-favourites",
    data: data,
  });
}

export function getFav(data: any) {
  return API({
    method: "get",
    url: `/api/customers/fetch-favourites?locationId=${data?.locationId}&customerId=${data?.customerId}`,
  });
}

export function exploreMenu(data: any){
  return API({
    method: 'get',
    url: `/api/customers/locations/${data?.locationId}/menu?orderType=${data?.menuType}`
  })
}
//coupon api's
export function getCoupon(data: any) {
  return API({
    method: "get",
    url: `/coupon/getActiveCoupons?locationId=${data?.locationId}&orderType=${data?.orderType}&visibleTo=${data.visibleTo}&customerId=${data.customerId}`,
  });
}



export function validateCoupon(data: any) {
const payload={
    // "offerId": "",
    customerId: data?.customerId,
    couponCode: data?.couponCode,
    locationId: data?.locationId,
     orderTotal:data?.orderTotal
    // "orderId": ""
   
}
 const encryptedData = encryptJson(payload);
  return API({
    method: "post",
    url: 'coupon/v2/validateCoupon',
    data :{data:encryptedData},
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function redeemCoupon(data: any) {

  const payload={
  "customer_id": "",
  "location_id": "",
  "order_id": "",
  "order_amount":0.0,
  "offer_id": ""
}
  return API({
    method: "post",
    url: 'coupon/v2/redeemCoupon',
     data :payload
  });
}
